import { supabase } from '../config/supabase';

export const logout = async () => {
  try {
    await supabase.auth.signOut();
  } catch (error) {
    console.error('Error during logout:', error);
  }
  
  // Clear any legacy stored data
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('user_email');
  localStorage.removeItem('user_role');
  
  // Redirect to signin
  window.location.href = '/signin';
};